module.exports = __webpack_public_path__ + "./fonts/ProximaSoft-Regular.ttf";